import React from 'react';
import moment from 'moment';
import { get, capitalize } from 'lodash';
import TableHeader from '../TableHeader';

import AdjustPointInput from './AdjustPointInput'

const PointHistoriesList = ({ points = [], total = 0, userId = 0, campaignId = 0 }) => {

  const formatBreakdown = (breakdown) => {
    if(breakdown) {
      return Object.keys(breakdown).map((breakdownKey) =>
        `${breakdownKey}: ${breakdown[breakdownKey]}`
      ).join(', ')
    }
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>User #{userId} Point history</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} point histories</p>
        </div>

        <div className='MainHeader__right'>
          <AdjustPointInput
            campaignId={campaignId}
            userId={userId}
            buttonTxt='Adjust Pt.'
          />
        </div>
      </div>

      <div className='Table Table--point-histories-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'Type'
            },
            {
              label: 'Points'
            },
            {
              label: 'Breakdown'
            },
            {
              label: 'Mission',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Mission type',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Created at',
              className: 'Table__col--ta-c'
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}
        {points.map((point) => (
          <div className={'Table__row'} key={`point_${point.id}`}>
            <div className='Table__col'>{capitalize(point.pointType)}</div>
            <div className='Table__col'>{point.totalPoints}</div>
            <div className='Table__col'>
              {formatBreakdown(point.breakdown)}
            </div>
            <div className='Table__col Table__col--ta-c'>{point.action}</div>
            <div className='Table__col Table__col--ta-c'>{capitalize(point.missionType)}</div>
            <div className='Table__col Table__col--ta-c'>{moment(get(point, 'createdAt')).format('YYYY-MM-DD HH:mm:ss')}</div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default PointHistoriesList
